import {
  PAGE_DOC,
  PAGE_INQUIRY,
  PAGE_LOGOUT,
  PAGE_MY_PAGE,
  PAGE_OPEN_API,
} from '@/constants';
import { useLanguageStore, useUserStore } from '@/store';
import { getFirstCapitalizedLetter } from '@/utils';
import { clearOrgGuideDismissed } from '@/views/dashboard/utils';
import type { LanguageType, MenuProps } from '@contiple/antd-ds';
import { Avatar, Config, Dropdown, Flex, theme } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

const Setting = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguageStore();
  const { user } = useUserStore();

  const initial = getFirstCapitalizedLetter(user?.email || '') || '';

  const languageItems: MenuProps['items'] = [
    ...Object.values(Config.Language).map((lang) => ({
      key: lang as string,
      disabled: lang === language,
      label: t(`language.${lang}`),
      onClick: () => {
        setLanguage(lang as LanguageType);
      },
    })),
  ];

  // Menu items for user settings
  const userMenu: MenuProps['items'] = [
    {
      key: 'my',
      label: t('setting.myPage'),
      onClick: () => {
        window.open(PAGE_MY_PAGE, '_blank');
      },
    },
    {
      key: 'language',
      label: (
        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
          {t('setting.language')}
        </Flex>
      ),
      children: languageItems,
    },
    {
      key: 'guide',
      label: t('setting.userGuide'),
      onClick: () => {
        window.open(PAGE_DOC, '_blank');
      },
    },
    {
      key: 'api',
      label: t('setting.openApi'),
      onClick: () => {
        window.open(PAGE_OPEN_API, '_blank');
      },
    },
    {
      key: 'inquiry',
      label: t('setting.support'),
      onClick: () => {
        window.open(PAGE_INQUIRY, '_blank');
      },
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: t('setting.logout'),
      onClick: () => {
        clearOrgGuideDismissed();
        location.href = PAGE_LOGOUT;
      },
    },
  ];

  return (
    <Dropdown
      menu={{
        items: userMenu,
      }}
      placement="bottomRight">
      <Avatar
        style={{
          cursor: 'pointer',
          lineHeight: token.Avatar?.containerSize,
        }}>
        {initial}
      </Avatar>
    </Dropdown>
  );
};

export default Setting;
